import { Accordion, Card, Checkbox, Col, DropdownBox, EventHandler, Label, OutlineButton, PopupDialogbox, Row, Tooltip } from 'client/CommonComponents'
import './PurchaseBulkOrder.scss'
import Moment from "moment";
import BulkOrderAssetDetail from './BulkOrderAssetDetail';
import PurchaseBulkOrderHeaderContainer from './PurchaseBulkOrderHeader/PurchaseBulkOrderHeader-container';
import ApprovalHistoryTimeLineCommon from 'client/CommonComponents/ApprovalHistoryTimeLineCommon';
import { formatPrice } from 'utils';
import { useMemo, useState } from 'react';
import { CONSTANTS } from 'client/utils/constants';
import { isAuthorized } from 'client/utils/Permissions';
import { FLEET_PROCESSING_PERMISSIONS } from 'client/utils/constants/fleetProcessingPermissions';

interface Iprops {
    Popupcontent: any,
    hideConfirmationDialog: any,
    bulkOrderHeaderDetails: any,
    bulkOrderFleetDetails: any,
    onChangeAccordian: any,
    bulkFleetHistoryTimeLine: any,
    id?: any,
    onAssignedToToggleChange?: any,
    assignTo?: any,
    onAssignedToDropdownChange?: any,
    isAssignedToChecked?: any,
    assignedToForAllValue?: any,
    getUserRoles?: any,
    handleBulkOrderCancel?: any
}

const PurchaseBulkOrder = ({ Popupcontent, hideConfirmationDialog, bulkOrderHeaderDetails, bulkOrderFleetDetails, onChangeAccordian, bulkFleetHistoryTimeLine, id,getUserRoles,handleBulkOrderCancel,
    onAssignedToToggleChange,
    assignTo,
    onAssignedToDropdownChange,
    isAssignedToChecked,
    assignedToForAllValue
}: Iprops) => {
    const assignToValue = useMemo(() => {
        return assignTo?.find(
            (x: any) => x.value === (assignedToForAllValue || "N/A")
        );
    }, [assignedToForAllValue, assignTo]);
    const ExpandedItems: any = [];
    bulkOrderFleetDetails?.map((item: any, index: any) => {

        const fleetItem = {
            headerText: <PurchaseBulkOrderHeaderContainer itemDetails={item} />,
            content: <BulkOrderAssetDetail itemDetails={item} id = {id} />,
            uuid: `Fleet_Accordion_${item.orderDetailId}`,
        }
        ExpandedItems.push(fleetItem)
    })

    return (
        <div className="fleetProcessing fleetprocessing-bulkorder mt-0">
            <Row>
                <Col xs={12} lg={12} className="BudgetCard DropDownAlligment">
                    <div className="card-radius">
                        <Card data-attribute="PurchaseBulkOrder_Default_Card">
                            <div className="accordionHeader">
                                <div className="accordionHeaderLeft fleet-bulk-order">
                                    <div>
                                        <p className="accord-heading blueLabel mt-2">LEADR ORDER# - {bulkOrderHeaderDetails?.orderRequestId}</p>
                                    </div>
                                    <div>
                                        <label className="labelText">Cost center</label>
                                        <Tooltip content={`${bulkOrderHeaderDetails?.costCenter}`} data-attribute="PurchaseBulkOrder_Default_Tooltip">
                                            <span className="dateContent">{bulkOrderHeaderDetails?.costCenter || "-"}</span>
                                        </Tooltip>
                                    </div>
                                </div>
                                <div className="accordionHeaderRight mt-sm-0 mt-2">
                                    <div>
                                        <label className="labelText ">Order Type{bulkOrderHeaderDetails?.orderRequestTypes?.length > 1 ? "s" : ""}</label>
                                        <Tooltip content={bulkOrderHeaderDetails?.orderRequestTypes?.map((item: any, index: any) => {
                                            return item + (index + 1 < bulkOrderHeaderDetails?.orderRequestTypes?.length ? ", " : "")
                                        })} data-attribute="PurchaseBulkOrder_Default_Tooltip_2">
                                            <span className="dateContent orderTypeLbl">
                                                {bulkOrderHeaderDetails?.orderRequestTypes?.map((item: any, index: any) => {
                                                    return item + (index + 1 < bulkOrderHeaderDetails?.orderRequestTypes?.length ? ", " : "")
                                                })}
                                            </span>
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <label className="labelText">Created Date</label>
                                        <Tooltip content={bulkOrderHeaderDetails?.createdDate
                                            ? Moment(bulkOrderHeaderDetails?.createdDate).format("MM/DD/YYYY")
                                            : "-"} data-attribute="PurchaseBulkOrder_Default_Tooltip_3">
                                            <span className="dateContent">
                                                {bulkOrderHeaderDetails?.createdDate
                                                    ? Moment(bulkOrderHeaderDetails?.createdDate).format("MM/DD/YYYY")
                                                    : "-"}
                                            </span>
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <label className="labelText">Updated Date</label>
                                        <Tooltip content={bulkOrderHeaderDetails?.updatedDate
                                            ? Moment(bulkOrderHeaderDetails?.updatedDate).format("MM/DD/YYYY")
                                            : "-"} data-attribute="PurchaseBulkOrder_Default_Tooltip_4">
                                            <span className="dateContent">
                                                {bulkOrderHeaderDetails?.updatedDate
                                                    ? Moment(bulkOrderHeaderDetails?.updatedDate).format("MM/DD/YYYY")
                                                    : "-"}
                                            </span>
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <label className="labelText">Requested By</label>
                                        <Tooltip content={`${bulkOrderHeaderDetails?.requestedBy || "-"}`} data-attribute="PurchaseBulkOrder_Default_Tooltip_5">
                                            <span className="dateContent">{bulkOrderHeaderDetails?.requestedBy || "-"}</span>
                                        </Tooltip>
                                    </div>
                                    <div>
                                        <label className="labelText">Order Total</label>
                                        <Tooltip content={bulkOrderHeaderDetails?.grandTotal ? `$${formatPrice(bulkOrderHeaderDetails?.grandTotal, 2)}` : "-"} data-attribute="PurchaseBulkOrder_Default_Tooltip_6">
                                            <span className="dateContent">{bulkOrderHeaderDetails?.grandTotal ? `$${formatPrice(bulkOrderHeaderDetails?.grandTotal, 2)}` : "-"}</span>
                                        </Tooltip>
                                    </div>

                                    {bulkOrderHeaderDetails?.quantity > 1 && <>
                                        <div className="bulkorderfleet_checkassigned">
                                            <div className="inside-checkbox">
                                                <Checkbox
                                                    onChange={(e: any) => onAssignedToToggleChange(e)}
                                                    disabled={bulkOrderHeaderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED || bulkOrderHeaderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.CANCELLED}
                                                    checked={!!isAssignedToChecked}
                                                    defaultChecked={false}
                                                 data-attribute="PurchaseBulkOrder_Default_Checkbox" />
                                                <span className="block-Text consolidatePO-block-text">
                                                    Set Assigned To for all Items
                                                </span>
                                            </div>
                                            <div className='assignedTo-fleet'>
                                                <Label data-attribute="PurchaseBulkOrder_Default_Label">Assigned To</Label>
                                                <DropdownBox
                                                    name="assignedTo"
                                                    placeholder="Select"
                                                    options={assignTo}
                                                    onChange={onAssignedToDropdownChange}
                                                    selectedKey={assignToValue?.key}
                                                    disabled = {bulkOrderHeaderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED || bulkOrderHeaderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.CANCELLED || !isAssignedToChecked}
                                                 data-attribute="PurchaseBulkOrder_assignedTo_Dropdown" />
                                            </div>
                                        </div>
                                    </>}
                                </div>
                            </div>
                        </Card>
                    </div>
                    <Card data-attribute="PurchaseBulkOrder_Default_Card_2">
                        <Accordion
                            Items={ExpandedItems}
                            className="custom-accordion LeaderOrderAccordion leaderOrderFleetProcessing"
                            onChange={(item: any) => onChangeAccordian(item)}
                            preExpanded={['Fleet_Accordion_0']}
                         data-attribute="PurchaseBulkOrder_Default_Accordion" />

                        {(getUserRoles()?.includes(CONSTANTS?.SUPER_ADMIN)) ?
                        <EventHandler  onEvent={(e: any) => e.stopPropagation()} data-attribute="PurchaseBulkOrder_Default_EventHandler">
                            <div className="mt-3 pr-25">
                                <OutlineButton
                                    text='Cancel Order'
                                    title='Cancel Order'
                                    className='cancel-btn me-0 pull-right'
                                    onClick={(e: any) => handleBulkOrderCancel(e)}
                                    disabled={
                                        !isAuthorized(FLEET_PROCESSING_PERMISSIONS?.DELETE_PURCHASEORDERS) || 
                                        bulkOrderHeaderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.COMPLETED || 
                                        bulkOrderHeaderDetails?.orderStatus === CONSTANTS?.ORDER_STATUS?.CANCELLED
                                    }
                                 data-attribute="PurchaseBulkOrder_Cancel_Order_Button" />
                            </div>
                        </EventHandler> : null}
                    </Card>
                </Col>
            </Row>
            {
                Popupcontent.isDialogVisible && (
                    <PopupDialogbox
                        hideDialog={!Popupcontent.isDialogVisible}
                        onDismiss={hideConfirmationDialog}
                        Popupcontent={Popupcontent}
                        popupOutlinebtnOnclick={() => Popupcontent?.popupOutlinebtnOnclick()}
                        popupPrimarybtnOnclick={(
                            item: any,
                            comment: string,
                            actionby: string,
                            value: any) => Popupcontent?.popupPrimarybtnOnclick(item,
                              comment,
                              actionby,
                              value)}
                     data-attribute="PurchaseBulkOrder_Default_PopupDilalogBox" />
                )
            }
        </div>
    )
}

export default PurchaseBulkOrder